import { parseDate } from './../helpers/date';

export class TimeStamped {
  created: Date;
  modified: Date;

  constructor(data: TimeStamped | DjangoTimeStamped = {}) {
    if (data instanceof TimeStamped) {
      bindTimeStampedData(this, data);
    } else {
      bindDjangoTimeStampedData(this, data);
    }
  }
}

export function parseTimeStamped(data?: TimeStamped | DjangoTimeStamped) {
  if (data) {
    return new TimeStamped(data);
  } else {
    return undefined;
  }
}

function bindTimeStampedData(timeStamped: TimeStamped, data: TimeStamped) {
  timeStamped.created = data.created;
  timeStamped.modified = data.modified;
}

////////////////////
// DJANGO SUPPORT //
////////////////////
export interface DjangoTimeStamped {
  created?: string;
  modified?: string;
}

function bindDjangoTimeStampedData(timeStamped: TimeStamped, data: DjangoTimeStamped) {
  timeStamped.created = parseDate(data.created);
  timeStamped.modified = parseDate(data.modified);
}
